// @ts-ignore
import React from "react";

import { MeResponse } from "@atlassiansox/asc-stargate";

import { AvailableProductsResponse } from "@/libraries/bxp-web-stargate-client/src";

import { JiraProductTourOverview } from "../../templates/jira-product-tour-overview/src";

export type JiraSoftwarePageProps = {
    availableProducts: AvailableProductsResponse | null;
    userProfile: MeResponse | null;
};

export const JiraSoftwarePage = (props: JiraSoftwarePageProps) => {
    const template = (
        <JiraProductTourOverview
            availableProducts={props.availableProducts}
            userProfile={props.userProfile}
        />
    );

    return template;
};
